import { FLOATING_ELEMENT_PLACEMENT } from '../../../constants/common'
import { AIButtonContainedDark, AIButtonOutlined } from '../../AIButton'
import { BUTTON_HEIGHT_32 } from '../../Button'
import { ICON_COLOR, ICON_HEIGHT_20 } from '../../Icon'

import {
  AIVoiceInputState,
  QA_NAME_AI_VOICE_INPUT,
} from './AIVoiceInput.constants'
import {
  isAIVoiceInputStateApplying,
  isAIVoiceInputStateConnecting,
  isAIVoiceInputStateReady,
  isAIVoiceInputStateRecording,
} from './AIVoiceInput.utils'

import * as styles from './AIVoiceInput.module.css'

import MicrophoneFilledIcon from '../../../icons/microphone-filled.svg'
import StopIcon from '../../../icons/stop.svg'

function AIVoiceInput({
  className = styles.aiVoiceInput,
  disabled,
  qaName = QA_NAME_AI_VOICE_INPUT,
  state = AIVoiceInputState.Default,
  stopButtonClassName = styles.stopButton,
  tooltip,
  tooltipPlacement = FLOATING_ELEMENT_PLACEMENT.top,
  onClick,
}) {
  const isStopState =
    isAIVoiceInputStateReady(state) || isAIVoiceInputStateRecording(state)

  const isProgressState =
    isAIVoiceInputStateConnecting(state) || isAIVoiceInputStateApplying(state)

  return isStopState ? (
    <AIButtonContainedDark
      beforeIconProps={{
        Icon: StopIcon,
        color: ICON_COLOR.White,
        height: ICON_HEIGHT_20,
      }}
      className={stopButtonClassName}
      disabled={disabled}
      height={BUTTON_HEIGHT_32}
      qaName={qaName}
      onClick={onClick}
    />
  ) : (
    <AIButtonOutlined
      beforeIconProps={{ Icon: MicrophoneFilledIcon, height: ICON_HEIGHT_20 }}
      className={className}
      disabled={disabled}
      height={BUTTON_HEIGHT_32}
      isLoading={isProgressState}
      qaName={qaName}
      tooltip={tooltip}
      tooltipPlacement={tooltipPlacement}
      onClick={onClick}
    />
  )
}

export default AIVoiceInput
